<div class="emails-type-list">
  <ng-container *ngIf="!loadingSpinner">
    <div class="email-type" *ngFor="let condWithTitle of activitiesWithTitle let i = index">
      <div class="email-type-title">
        {{condWithTitle.title}}
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let cond of condWithTitle.conditions; let j = index"
                  [ngClass]="{'colored-button': cond.color !== '000000'}"
                  [style.background-color]="cond.color !== '000000' ? ('#' + cond.color) : '#e4e4e4'"
                  (click)="editActivity(cond, i, j)">
            {{cond.title}}
          </button>
        </div>
      </div>
    </div>

    <div class="email-type">
      <div class="email-type-title">
        Production Planning
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let post of productionPosts; let i = index"
                  (click)="editPost(post, i)">
            {{post.name}}
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="loading-body" *ngIf="loadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

</div>
